import { CLEAR_PROFILE, FETCH_PROFILE_FAILURE, FETCH_PROFILE_REQUEST, FETCH_PROFILE_SUCCESS, UPDATE_PROFILE_FAILURE, UPDATE_PROFILE_REQUEST, UPDATE_PROFILE_SUCCESS } from "./profileType";


export const fetchProfile = (ProfileId) => {

    return {
      type: FETCH_PROFILE_REQUEST,
      payload: { ProfileId},
    };
  };
  
  export const fetchProfileSuccess = (Profiles) => {
  
    return {
      type: FETCH_PROFILE_SUCCESS,
      payload: { Profiles },
    };
  };
  
  export const fetchProfileFailure = (error) => {
  
    return {
      type: FETCH_PROFILE_FAILURE,
      payload: { error },
    };
  };
  export const updateProfile = (ProfileId, ProfileData) => {
    return {
      type: UPDATE_PROFILE_REQUEST,
      payload: { ProfileId, ProfileData },
    };
  };
  
  export const updateProfileSuccess = (Profile) => ({
    type: UPDATE_PROFILE_SUCCESS,
    payload: { Profile },
  });
  
  export const updateProfileFailure = (error) => ({
    type: UPDATE_PROFILE_FAILURE,
    payload: { error },
  });
  export const resetCurrentProfile = () => ({
    type: CLEAR_PROFILE,
  });